import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";
import { Sparkles } from "lucide-react";

const ZODIAC = {
  Aries: "♈", Taurus: "♉", Gemini: "♊", Cancer: "♋", Leo: "♌", Virgo: "♍",
  Libra: "♎", Scorpio: "♏", Sagittarius: "♐", Capricorn: "♑", Aquarius: "♒", Pisces: "♓",
};

const PLANET_ICONS = {
  Sun: "☉", Moon: "☾", Mercury: "☿", Venus: "♀", Mars: "♂",
  Jupiter: "♃", Saturn: "♄", Uranus: "♅", Neptune: "♆", Pluto: "♇",
};

const _extractPlanets = (natal) => {
  if (!natal?.planets) return [];
  const p = natal.planets;
  if (Array.isArray(p)) return p;
  // some shapes: { planets: [...] }
  if (Array.isArray(p.planets)) return p.planets;
  return [];
};

export const NatalChartCard = ({ natal }) => {
  const planets = _extractPlanets(natal);
  const safeRows = planets
    .filter((pl) => pl && (pl.name || pl.full_name))
    .slice(0, 10)
    .map((pl) => ({
      name: pl.name || pl.full_name,
      sign: pl.sign || pl.sign_name || "—",
      degree: pl.normDegree
        ? `${Number(pl.normDegree).toFixed(1)}°`
        : pl.norm_degree
        ? `${Number(pl.norm_degree).toFixed(1)}°`
        : pl.fullDegree
        ? `${Number(pl.fullDegree).toFixed(1)}°`
        : "",
      house: pl.house || "",
    }));

  return (
    <Card
      data-testid="natal-chart-card"
      className="border-white/10 bg-[#111625]/80 backdrop-blur-xl text-[#F8FAFC] shadow-[0_8px_32px_rgba(0,0,0,0.4)] h-full"
    >
      <CardHeader className="pb-3">
        <CardTitle className="font-serif-mystic text-2xl flex items-center gap-2">
          <Sparkles size={18} className="text-[#D4AF37]" strokeWidth={1.5} />
          Natal Chart
        </CardTitle>
        <p className="text-xs uppercase tracking-[0.2em] text-[#94A3B8]">
          Swiss Ephemeris · Western Tropical
        </p>
      </CardHeader>
      <CardContent>
        {safeRows.length === 0 ? (
          <div className="text-sm text-[#94A3B8] py-6">
            Natal data is preparing. If this persists, your chart will sync after your next login.
          </div>
        ) : (
          <ul className="space-y-2">
            {safeRows.map((row, i) => (
              <li
                key={i}
                className="flex items-center justify-between py-1.5 border-b border-white/5 last:border-0"
                data-testid={`natal-row-${row.name?.toLowerCase()}`}
              >
                <div className="flex items-center gap-3">
                  <span className="text-[#D4AF37] w-6 text-center text-base">
                    {PLANET_ICONS[row.name] || "•"}
                  </span>
                  <span className="font-serif-mystic text-lg">{row.name}</span>
                </div>
                <div className="flex items-center gap-2 text-sm text-[#94A3B8]">
                  <span>{row.degree}</span>
                  <span className="text-[#F3E5AB] text-base">{ZODIAC[row.sign] || ""}</span>
                  <span className="w-20 text-right">{row.sign}</span>
                </div>
              </li>
            ))}
          </ul>
        )}
      </CardContent>
    </Card>
  );
};
